import { Injectable } from '@angular/core';

import { QueryEntity } from '@datorama/akita';

import { FloorPlanState } from './floor-plan.state';
import { FloorPlanStore } from './floor-plan.store';

@Injectable({ providedIn: 'root' })
export class FloorPlanQuery extends QueryEntity<FloorPlanState> {
  constructor(protected readonly store: FloorPlanStore) {
    super(store);
  }
}
